module.exports = __webpack_public_path__ + "img/1.52e5ff24.png";